import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { CerrixIconButtonComponent } from "@app/shared/atoms/cerrix-icon-button/cerrix-icon-button.component";
import { CerrixTitleComponent } from "@app/shared/atoms/cerrix-title/cerrix-title.component";
import { CerrixWorkflowBarComponent } from "@app/shared/cerrix-workflow-bar/cerrix-workflow-bar.component";
import { WorkflowStepItemModel } from "@app/shared/cerrix-workflow-bar/models/workflow-step-item";
import { CerrixInputValidationErrorsDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-errors.directive";
import { CerrixInputValidationMaxLengthDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-max-length.directive";
import { CerrixInputValidationRequiredDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-required.directive";
import { CerrixBreadcrumbComponent } from "@app/shared/molecules/cerrix-breadcrumb/cerrix-breadcrumb.component";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "./i18n/scope";

@Component({
    selector: "app-cerrix-header",
    templateUrl: "./cerrix-header.component.html",
    styleUrls: ["./cerrix-header.component.scss"],
    imports: [
        TranslatePipe,
        CerrixTitleComponent,
        CerrixIconButtonComponent,
        CerrixWorkflowBarComponent,
        CerrixBreadcrumbComponent,
        CerrixInputValidationErrorsDirective,
        CerrixInputValidationMaxLengthDirective,
        CerrixInputValidationRequiredDirective,
    ],
    viewProviders: [provideTranslationScope(scope)],
    encapsulation: ViewEncapsulation.None,
})
export class CerrixHeaderComponent {
    @Input() title: string;
    @Input() titlePlaceholder: string;
    @Input() edit: boolean = false;
    @Input() requiredMessage: string | null = null;
    @Input() maxLength: number = 300;
    @Input() public workflowSteps: WorkflowStepItemModel[] = [];
    @Input() public breadcrumbs: string[] = [];
    /** The icon of an edit button next to the read-only title. Without it, no button shows. */
    @Input() editIcon?: string;

    @Output() titleChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() editRequested = new EventEmitter<void>();
}
